import React, { useContext, useEffect } from "react";
import NewCareerPageHero from "./NewCareerPageHero";
import Position from "./Position";
import { AuthContext } from "../../context/AuthContext";

const NewCareerPage = () => {
  const dataContext = useContext(AuthContext);

  useEffect(() => {
    // Set Page Title
    document.title = "Careers at TechQilla | Digital Marketing Jobs India";

    // --- Description ---
    let metaDescription = document.querySelector<HTMLMetaElement>(
      "meta[name='description']",
    );
    if (!metaDescription) {
      metaDescription = document.createElement("meta");
      metaDescription.name = "description";
      document.head.appendChild(metaDescription);
    }
    metaDescription.setAttribute(
      "content",
      "Join TechQilla and build your career in digital marketing, web development, design, and technology. Explore current job openings today.",
    );

    // --- Keywords ---
    let metaKeywords = document.querySelector<HTMLMetaElement>(
      "meta[name='keywords']",
    );
    if (!metaKeywords) {
      metaKeywords = document.createElement("meta");
      metaKeywords.name = "keywords";
      document.head.appendChild(metaKeywords);
    }
    metaKeywords.setAttribute("content", "Digital Marketing Jobs India");
    // --- Canonical ---
    let linkTag = document.querySelector<HTMLLinkElement>(
      "link[rel='canonical']",
    );
    if (!linkTag) {
      linkTag = document.createElement("link");
      linkTag.rel = "canonical";
      document.head.appendChild(linkTag);
    }
    linkTag.setAttribute("href", " https://www.techqilla.com/careers");
  }, []);

  if (!dataContext) return null;
  const { theme } = dataContext;
  return (
    <div>
      <NewCareerPageHero />
      <div
        className={
          theme === "dark"
            ? "bg-primary text-white transition-all duration-500"
            : "bg-black text-white transition-all duration-500"
        }
      >
        <div className="flex flex-col mx-auto max-w-screen-2xl items-center justify-center overflow-hidden py-8">
          <Position />
        </div>
      </div>
    </div>
  );
};

export default NewCareerPage;
